<script setup>
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import {useMutation, useQueryClient} from "@tanstack/vue-query";
import axios from "axios";
import SweetToast from "../../../../SweetToast";
import {ref} from "vue";
import GeneratedKeyModal from "../GeneratedKeyModal.vue";

const keyName = ref('');
const token = ref('');
const errors = ref({});
const showGeneratedKeyModal = ref(false);
const queryClient = useQueryClient();

const {mutate: generateApiKey, isPending} = useMutation({
  mutationFn: async () => await axios.post('/ajax/v2/api-keys', {
    name: keyName.value,
  }),
  onSuccess: ({data}) => {
    token.value = data.data.token
    showGeneratedKeyModal.value = true;
    keyName.value = '';
    errors.value = {}
    queryClient.invalidateQueries({ queryKey: ['api-keys'] })
  },
  onError: ({response}) => {
    const {data} = response
    errors.value = data.errors ?? {}
    SweetToast.fire({
      icon: 'error',
      title: 'There was an error generating your API Key',
    });
  },
});

const handleCloseGeneratedKeyModal = async () => {
  showGeneratedKeyModal.value = false;
  token.value = '';
}

</script>

<template>
  <div class="tw-flex tw-items-center">
    <p class="tw-w-1/3 tw-font-bold tw-text-[15px]">
      Enter API Key Name
    </p>
    <div class="tw-flex tw-justify-center tw-px-2 tw-grow tw-rounded tw-border tw-border-neutral-500 tw-py-3">
      <input
        v-model="keyName"
        type="text"
        required
        class="tw-w-full"
        placeholder="Enter API Key Name"
        :class="{
          'error': errors.name
        }"
      >
    </div>
  </div>
  <div class="tw-flex tw-mb-10">
    <div class="tw-flex-col tw-grow">
      <div class="tw-h-7">
        <p
          class="tw-text-danger tw-font-bold"
          v-text="Array.isArray(errors.name) ? errors.name[0] : errors.name"
        />
      </div>
      <div class="tw-flex tw-justify-end">
        <DefaultButton
          variant="primary"
          :disabled="isPending"
          @click="generateApiKey"
        >
          <svg-vue
            v-if="isPending"
            class="tw-h-6 tw-mr-2"
            icon="icons/loading"
          />
          {{ isPending ? 'Generating key' : 'Generate Key' }}
        </DefaultButton>
      </div>
    </div>
  </div>

  <GeneratedKeyModal
    v-if="showGeneratedKeyModal"
    :token="token"
    @close="handleCloseGeneratedKeyModal"
  />
</template>

<style scoped>

</style>
